export default __webpack_public_path__ + "static/media/Chauffeur-livreur.08428472.png";